import {tryParseJSON} from "../common/components/utils"
import SwiperCom from "../common/components/swiper"
import {setupTabs} from "../common/components/tabs"
import {setupDropdown} from "./semantic-ui"
import {ApiRequest} from "./request"
import addRequests from "./add-requests";

export function amountValidate()
{
    const wrap_el = document.querySelector('#amount-wrap'),
        input_el = wrap_el.querySelector('input[name="amount"]');
    const error_msg = document.createElement('div');
    error_msg.classList.add('error');
    error_msg.classList.add('invalid-feedback');
    error_msg.innerHTML = '<div>The minimum amount you can add is $500.</div>';

    if(wrap_el && input_el){
        if(!input_el.value || input_el.value < 500){
            wrap_el.classList.add('error-wrap');
            if(!wrap_el.parentElement.querySelector('.invalid-feedback')) wrap_el.parentElement.appendChild(error_msg);

            if (input_el.getAttribute('keydown_listener') !== 'true') {
                input_el.addEventListener('keydown', function (e) {
                    e.target.setAttribute('keydown_listener', 'true');
                    wrap_el.classList.remove('error-wrap');
                });
            }
            if (input_el.getAttribute('changed_listener') !== 'true') {
                input_el.addEventListener('change', function (e) {
                    e.target.setAttribute('changed_listener', 'true');
                    wrap_el.classList.remove('error-wrap');
                });
            }
            return false;
        }
        wrap_el.classList.remove('error-wrap');
        wrap_el.parentElement.querySelector('.invalid-feedback')?.remove();
    }
    return true;
}

export default function(app){

    /**
     * Show the overlay loader
     *
     * @return void
     */

    function showLoader()
    {
        $('.overlay-loader').css({zIndex: 99999}).addClass('show')
    }

    /**
     * Hide the overlay loader
     *
     * @return void
     */

    function hideLoader()
    {
        $('.overlay-loader').css({zIndex: -1}).removeClass('show')
        setTimeout(function(){
            $('.overlay-loader').removeAttr('style')
        }, 500)
    }

    /*
     * Get overlay component from page
     */

    function getOverlay(overlayClass)
    {
        return document.querySelector('.overlay-com.' + overlayClass)
    }

    /**
     * Activate the first tab with error
     *
     * @return void
     */

    function firstTabWithError()
    {

        // Get the overlays list
        const $overlays = $('.overlay-com')

        // Stop if no overlays
        if($overlays.length === 0) return

        // For each overlay
        $overlays.each(function(){

            // Get the overlay
            const $overlay = $(this)

            // Get the tabs list
            const $tabsContainer = $overlay.find('.tabs-container')

            // Stop if no tabs in overlay
            if($tabsContainer.length === 0) return

            // Get the first input with error
            const $firstError = $tabsContainer.find('.error.invalid-feedback:first')

            // Stop if no error
            if($firstError.length === 0) return

            // Get the tab index
            const tabIndex = $firstError.parents('.tab-content').index()

            const $tabTriggers = $tabsContainer.find('.tabs-list .tab-title')
            const $tabContent = $tabsContainer.find('.tabs-content .tab-content')

            // Remove the active class
            $tabTriggers.removeClass('active')
            $tabContent.removeClass('active')

            // Show the tab with error
            $tabTriggers.eq(tabIndex).addClass('active')
            $tabContent.eq(tabIndex).addClass('active')

        })

    }

    /*
     * Show overlay on page
     *
     * @return void
     */

    function showOverlay(overlayClass, withClean = false)
    {

        let overlay = getOverlay(overlayClass)

        if(overlay) {

            if(withClean) clearFields(overlay)

            let overlays = $('.overlay-com:visible:not(.remote-overlay)')

            if(overlays.length) {

                // Close all overlays before opening the new one
                overlays.each(function(){
                    const el = $(this)[0]
                    closeOverlay(null, el)
                })

                // Show overlay after the others are closed
                setTimeout(function(){

                    // Show the overlay
                    overlay.classList.add('show')

                }, 400)

            } else {

                // Show overlay instantly
                overlay.classList.add('show')

            }

            document.body.classList.add('overlay-on')

            const onShown = overlay.getAttribute('data-on-shown');
            if(window[onShown] && typeof window[onShown] === 'function') {
                window[onShown]()
            }

        } else {

            console.error(`Overlay "${overlayClass}" was not found`)

        }
    }

    /*
     * Close the overlay
     *
     * @return void
     */

    function closeOverlay(event, overlay)
    {

        if(event) event.preventDefault()

        const overlayEvent = new Event('close')

        overlay.classList.add('hide')
        overlay.dispatchEvent(overlayEvent)

        setTimeout(function(){
            overlay.classList.remove('show')
            overlay.classList.remove('hide')
            document.body.classList.remove('overlay-on')

            // Remove the overlay
            if(overlay.getAttribute('data-remove-on-close') || overlay.classList.contains('remote-overlay')) return overlay.remove()

            clearFields(overlay)

        }, 400)

        return false

    }

    /*
     * Clear overlay fields
     *
     * @return void
     */

    function clearFields(overlay)
    {

        // Skip form input clearing
        if(!overlay.classList.contains('with-clean')) return

        // Emit event to clear dropdowns within overlay
        app.events.emit('kx_dropdownClear', { element: overlay })

        // Clear input values
        overlay.querySelectorAll('.f-field').forEach((field) => {
            field.value = ''
        })

        // Trigger form reset
        overlay.querySelectorAll('.form-panel')[0].reset()

        // Clear input values
        overlay.querySelectorAll('.form-field').forEach((field) => {

            // Remove field error class
            field.classList.remove('with-error')

            // Remove error message element
            let errorEl = field.querySelector('.error')
            if(errorEl) errorEl.remove()

        })

    }

    /*
     * Fill overlay data from API endpoint
     *
     * @return void
     */

    async function fillOverlay(overlayClass, apiRoute, method)
    {

        // Show the overlay loader
        showLoader()

        let response = await ApiRequest(apiRoute, null, method)
        let overlay = getOverlay(overlayClass)

        // Exit
        if(!response || !overlay) return

        // Hide the loader
        hideLoader()

        // Show overlay after inputs where filled
        showOverlay(overlayClass)

        // If we have a form panel action
        if(response.formPanelAction) {

            // Get the form panel
            const formPanel = overlay.querySelectorAll('form.form-panel')

            // Update the form panel action
            if(formPanel.length > 0) formPanel[0].setAttribute('action', response.formPanelAction)

        }

        clearFields(overlay)

        // Iterate over keys and fill inputs
        for(let key in response) {

            let value = response[key]

            // Get input by data attribute
            let field = overlay.querySelector(`[data-map^="${key}:"]`)

            // Jump to next iteration if field not found
            if(!field) continue

            let dataMap = field.getAttribute('data-map')
            let type = dataMap.split(':')[1]

            switch (type) {

                case 'dropdown': {

                    // Emit event to set values on dropdown
                    app.events.emit('kx_dropdownSetSelected', {
                        values: tryParseJSON(value),
                        field: field
                    })

                    break
                }

                case 'checkbox': {
                    if(['active', 'public', 'enabled', true].includes(value)) {
                        field.setAttribute('checked', 'checked')
                    } else {
                        field.removeAttribute('checked')
                    }

                    break
                }

                case 'datepicker': {
                    // Emit event to set values on datepicker
                    app.events.emit('kx_datepickerSetSelected', {
                        value, dataMap
                    })

                    break
                }

                default: {
                    field.value = value

                    break
                }
            }

        }

    }

    /*
     * Bind the close overlay action
     *
     * @return void
     */

    function bindCloseOverlay(overlays)
    {

        overlays.forEach(function(overlay)
        {

            let closeBtns = overlay.querySelectorAll('.close-btn')
            let bg = overlay.querySelector('.bg')

            let closeEvent = (event) => {
                closeOverlay(event, overlay)
            }

            closeBtns.forEach((closeButton) =>{
                closeButton.addEventListener('touch', closeEvent)
                closeButton.addEventListener('click', closeEvent)
            })

            if(bg.length === 0) return

            bg.addEventListener('touch', closeEvent)
            bg.addEventListener('click', closeEvent)

        })

    }

    /*
     * Init overlay listeners
     *
     * - open overlays
     */

    function initOverlayListeners()
    {

        const overlayButtons = document.querySelectorAll('[data-overlay]')

        overlayButtons.forEach(function(el){

            el.addEventListener('click', (e) => {

                e.preventDefault()

                let overlayClass = el.getAttribute('data-overlay')
                let overlaySkipClean = el.hasAttribute('data-skip-clean')
                let overlayAction = el.getAttribute('data-action')
                if(overlayAction) {
                    let overlay = getOverlay(overlayClass)
                    overlay.querySelector('form.form-panel').setAttribute("action", overlayAction)
                }

                let overlayRoute = el.getAttribute('data-route')

                if(overlayRoute) {
                    fillOverlay(overlayClass, overlayRoute, el.getAttribute('data-method') || 'POST')
                } else if(overlayClass) {
                    showOverlay(overlayClass, !overlaySkipClean)
                }

            })

        })

    }

    /**
     * Open a remote overlay
     *
     * @param event
     *
     * @return {Promise<void>}
     */

    async function openRemoteOverlay(event)
    {
        // Prevent the default action
        event.preventDefault()
        let requestArgs = {};

        if(!validation(event, requestArgs)) return false;

        const trigger = $(this)[0]

        // Show the loader
        showLoader()

        let method = 'GET'

        const token = trigger.getAttribute('data-token');

        if(token) {
            method = 'POST'
            requestArgs._token = token
        }

        let data = null
        if(Object.keys(requestArgs).length > 0){
            data = JSON.stringify(requestArgs)
        }

        // Get the overlay content
        let response = await ApiRequest(trigger.getAttribute('data-remote-overlay'), data , method, data ? 'application/json' : 'text/html')

        try {
            const json = JSON.parse(response)
            if(json.url) return window.location = json.url
        } catch(err) {}

        // Hide the overlay loader
        hideLoader()

        // Add the overlay to the body
        $('body').append(response)

        addRequests()

        // Get the overlays
        const overlays = document.querySelectorAll('.overlay-com.remote-overlay')

        // Bind the close overlay
        bindCloseOverlay(overlays)

        if(overlays[0]) {
            setupTabs(overlays[0])
            setupDropdown($(overlays[0]), app)
            SwiperCom(app, overlays[0])
        }

        // Show the overlay
        showOverlay('remote-overlay')

    }

    function validation(event, args, returnedContentType){
        const el = event.currentTarget,
            mode = el.getAttribute('data-mode');

        let result = true;
        switch (mode){
            case 'add-funds':
                result = amountValidate();
                if(result){
                    const wrap_el = document.querySelector('#amount-wrap'),
                        input_el = wrap_el.querySelector('input[name="amount"]');
                    args.amount = input_el.value
                }
                break
        }
        return result
    }

    initOverlayListeners()

    // Get the overlays list
    const overlays = document.querySelectorAll('.overlay-com')

    // Bind the close overlay button
    if(overlays.length > 0) bindCloseOverlay(overlays)

    $(function(){

        firstTabWithError()

        const $body = $('body')

        $body.on('click', '[data-remote-overlay]', openRemoteOverlay)

    })

    return {
        hideLoader,
        showLoader
    }

}
